import { SectionHeading } from '@/components/ui/Panel';
import { InlineError } from '@/components/ui/EmptyState';
import { Skeleton } from '@/components/ui/Skeleton';
import { ProfileSection } from '@/components/settings/ProfileSection';
import { PasswordSection } from '@/components/settings/PasswordSection';
import { TwoFactorSection } from '@/components/settings/TwoFactorSection';
import { SessionsSection } from '@/components/settings/SessionsSection';
import { NotificationsSection } from '@/components/settings/NotificationsSection';
import { AppearanceSection } from '@/components/settings/AppearanceSection';
import { SignOutSection } from '@/components/settings/SignOutSection';
import { useProfile } from '@/lib/queries';
import { toMessage } from '@/lib/api';

export default function SettingsPage() {
  const profile = useProfile();

  return (
    <div>
      <header>
        <h1 className="text-xl font-semibold tracking-tight text-fg">Настройки</h1>
        <p className="mt-1.5 max-w-prose text-sm text-fg-secondary">
          Данные аккаунта, безопасность и то, о чём вам сообщать.
        </p>
      </header>

      <SectionHeading>Аккаунт</SectionHeading>
      {profile.isPending ? (
        <ProfileSkeleton />
      ) : profile.isError ? (
        <InlineError
          message={toMessage(profile.error, 'Не удалось загрузить профиль.')}
          onRetry={() => void profile.refetch()}
        />
      ) : (
        <ProfileSection profile={profile.data} />
      )}

      <SectionHeading>Безопасность</SectionHeading>
      <div className="space-y-4">
        <PasswordSection />
        {profile.data ? <TwoFactorSection enabled={profile.data.twoFaEnabled} /> : null}
        <SessionsSection />
      </div>

      <SectionHeading>Уведомления</SectionHeading>
      <NotificationsSection />

      <SectionHeading>Оформление</SectionHeading>
      <AppearanceSection />

      <SectionHeading>Сессия</SectionHeading>
      <SignOutSection />
    </div>
  );
}

function ProfileSkeleton() {
  return (
    <div className="rounded-md border border-line bg-surface" role="status" aria-busy="true">
      <span className="sr-only">Загружаю профиль</span>
      <div className="border-b border-line px-4 py-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="mt-2 h-3 w-64" />
      </div>
      <div className="space-y-4 px-4 py-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <div>
            <Skeleton className="h-2.5 w-14" />
            <Skeleton className="mt-1.5 h-4 w-48" />
          </div>
          <div>
            <Skeleton className="h-2.5 w-20" />
            <Skeleton className="mt-1.5 h-4 w-28" />
          </div>
        </div>
        <Skeleton className="h-9 w-full max-w-prose" />
      </div>
    </div>
  );
}
